"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _formatPriceCurrency = _interopRequireDefault(require("./formatPriceCurrency"));

var findAndformatLowestPrice = function findAndformatLowestPrice(_ref) {
  var products = _ref.products,
      locale = _ref.locale;
  var lowestPrice = products.reduce(function (min, product) {
    return product.price < min ? product.price : min;
  }, products[0].price);
  return (0, _formatPriceCurrency["default"])(lowestPrice, products[0].currency, locale);
};

var _default = findAndformatLowestPrice;
exports["default"] = _default;
//# sourceMappingURL=findAndformatLowestPrice.js.map